const Orientations = {
	A4: {
		landscape: 'landscape',
		portrait: 'portrait'
	}
}
export default Orientations;
